<!-- Only God and Me knew how this logic worked when I wrote this. Now only God knows. -->
<template>
  <el-form
    v-if="isLoaded"
    :model="setAmountForm"
    :rules="getFormRules"
    ref="setAmountForm"
    label-position="top"
    v-loading.fullscreen.lock="fullScreenLoading"
  >
    <el-row>
      <el-form-item style="text-align: center;">
        <el-upload
          class="reconciliation-excel__uploader"
          drag
          action="#"
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          :on-exceed="handleExceed"
          :http-request="uploadExcel"
          :before-upload="beforeExcelUpload"
          :file-list="excelFiles"
        >
          <i class="el-icon-upload" />
          <div class="el-upload__text">
            {{ $t('re-conciliation.uploader.upload-text') }} <em>{{ $t('re-conciliation.uploader.click-to-upload') }}</em>
          </div>
        </el-upload>
      </el-form-item>
    </el-row>
    <el-row class="reconciliation-excel__manually">
      <span>{{ $t('re-conciliation.uploader.enter-manually') }}</span>
    </el-row>
    <el-row
      v-if="poolingStrategy !== 'auto-pooling'"
      class="amount-switcher"
    >
      <el-form-item
        class="amount-type-change"
      >
        <el-switch
          v-model="amountType"
          inactive-color="#FF8A00"
          active-color="#FF8A00"
          :inactive-text="$t('re-conciliation.set-amount.amount')"
          :active-text="$t('re-conciliation.set-amount.percent')"
          inactive-value="amount"
          active-value="percentage"
        />
      </el-form-item>
    </el-row>
    <el-row class="amount">
      <el-col :span="12">
        <h2>
          {{ $t('re-conciliation.set-amount.total-pay') }}: {{
            (roundToDecimals(totalPay / 100)).toLocaleString($localeString, {
              style: 'currency',
              currency: currency
            })
          }}
        </h2>
      </el-col>
      <el-col :span="12">
        <h2 v-if="amountType === 'amount'">
          {{ $t('re-conciliation.set-amount.residual-amount') }}:
          {{
            (roundToDecimals(residualAmount / 100)).toLocaleString($localeString, {
              style: 'currency',
              currency: currency
            })
          }}
        </h2>
        <h2 v-else>
          {{ $t('re-conciliation.residual-percents') }}: {{ roundToDecimals(residualPercents / 100) }} %
        </h2>
      </el-col>
    </el-row>
    <el-row class="equals-buttons mt-20">
      <el-col :span="11">
        <el-button
          type="default"
          class="primary-outline-button"
          @click="equalToAll"
        >
          {{ $t('re-conciliation.set-amount.equal-to-all') }}
        </el-button>
      </el-col>
      <el-col
        :offset="2"
        :span="11"
      >
        <el-button
          type="default"
          class="primary-outline-button"
          @click="equalToRemain"
          :disabled="isDisabledRemainButton"
        >
          {{ $t('re-conciliation.set-amount.equal-to-remain') }}
        </el-button>
      </el-col>
    </el-row>
    <div class="employees">
      <el-row
        v-for="(employee, index) in employees"
        :key="index"
        class="mt-20"
      >
        <el-form-item
          prop="amount"
        >
          <el-col :span="6">
            <h3 :style="{fontWeight: (employee.empUid === employee.teamContactUid) ? 'bold' : 'initial'}">
              {{ `${employee.name} ${employee.surName}` }}
            </h3>
          </el-col>
          <el-col :span="18">
            <el-input-number
              ref="employeeInputNumber"
              :controls="false"
              :value="roundToDecimals(employee.amount / 100)"
              :min="0"
              :max="roundToDecimals(employee.maxAmount / 100)"
              :precision="2"
              @change="changeAmount(employee, $event)"
            />
          </el-col>
        </el-form-item>
      </el-row>
    </div>
    <el-form-item>
      <el-row class="mt-20 mb-20">
        <el-col :span="11">
          <el-button
            type="cancel"
            class="cancel-button"
            @click="resetForm"
          >
            {{ $t('form.reset') }}
          </el-button>
        </el-col>
        <el-col
          :offset="2"
          :span="11"
        >
          <el-button
            :disabled="residualAvailable"
            type="primary"
            class="primary-button"
            @click="submitForm('setAmountForm')"
          >
            {{ $t('form.confirm') }}
          </el-button>
          <div
            style="margin-top: 6px"
            v-if="residualAvailable"
            class="el-form-item__error"
          >
            {{ $t("form.validation.residual-amount") }}
          </div>
        </el-col>
      </el-row>
    </el-form-item>
  </el-form>
</template>

<script>

import { Auth } from '@aws-amplify/auth'

export default {
  name: 'SetAmount',

  data: function () {
    return {
      isLoaded: false,
      teams: [],
      fullScreenLoading: true,
      employees: [],
      setAmountForm: {},
      residualAmount: 0,
      residualPercents: 0,
      totalPay: 0,
      amountType: (this.poolingStrategy === 'auto-pooling') ? 'percentage' : 'amount',
      isDisabledRemainButton: false,
      currency: 'EUR',
      excelFiles: [],
      residualAvailable: false,
    };
  },
  computed: {
    poolingStrategy () {
      const team = this.teams.find((el) => {
        return el.id === this.$route.params.teamId;
      });
      return team.poolingStrategy || 'complex';
    },
    getFormRules () {
      const amountValidate = (rule, value, callback) => {
        this.checkResidual();
        let valid = false;
        this.employees.map((employee) => {
          if (employee.amount > 0) {
            valid = true;
          }
        });
        if (!valid) {
          callback(new Error(this.$t('form.validation.one-item-filled')));
        } else {
          callback();
        }
      };
      return {
        amount: [
          { validator: amountValidate, trigger: ['blur', 'change'] }
        ]
      };
    }
  },
  created () {
    Auth.currentAuthenticatedUser().then((user) => {
      this.$adminApi.get(`/api/v1/entities/teams/representatives/${user.attributes.sub}`).then((teams) => {
        this.teams = teams.data;
        this.isLoaded = true;
        this.$adminApi.get(`/api/v1/entities/teams/${this.$route.params.teamId}/reconciliation`, {
          params: {
            period_start: this.$route.params.startDate || '',
            period_end: this.$route.params.endDate || ''
          }
        }).then((response) => {
          this.residualAmount = this.totalPay = response.data.payload.toReconcile;
          this.checkResidual();
          this.currency = response.data.payload.currency ?? 'EUR';
          if (this.totalPay) {
            this.residualPercents = 10000;
          }
          this.$axios.get(`/api/v1/teams/${this.$route.params.teamId}/employees`, {
            params: {
              compress: true
            }
          }).then((response) => {
            this.employees = response.data;
            this.employees.forEach((employee) => {
              employee.amount = 0;
              employee.maxAmount = this.residualAmount;
            });
            if (this.poolingStrategy === 'auto-pooling' && this.totalPay) {
              this.employees.forEach((employee) => {
                this.changeAmount(employee, employee.autoPoolingPercent / 100);
              });
            }
            this.fullScreenLoading = false;
          }).catch(() => {
            this.fullScreenLoading = false;
          });
        }).catch(() => {
          this.fullScreenLoading = false;
        });
      });
    });
  },
  updated() {
    const numberInputList = this.$refs["employeeInputNumber"];
    if (!this.addedListeners && numberInputList != null) {
      this.addedListeners = true;
      numberInputList.forEach((el, key) => {
        el.$el.querySelector('.el-input__inner').addEventListener('paste', (e) => {
          e.preventDefault();
          let paste = (e.clipboardData || window.clipboardData).getData("text");
          paste = Number(paste.replace(",", "."))
          if(!Number.isNaN(paste) && this.employees[key].maxAmount / 100 >= paste) {
            el.$el.querySelector('.el-input__inner').value = paste
            this.changeAmount(this.employees[key], paste)
          }
        })

        el.$el.querySelector('.el-input__inner').addEventListener('input', (e) => {
          e.preventDefault();
          const string = e.target.value
          let timerId = null
          clearInterval(timerId)
          timerId = setTimeout(() => {
            if(string.indexOf(",") !== -1) {
            const splittedString = string.split(',')
            let val = e.target.value.replace(",", ".")
          if( splittedString[1]?.length && !Number.isNaN(val) && this.employees[key].maxAmount / 100 >= val) {
              el.$el.querySelector('.el-input__inner').value = val
              this.changeAmount(this.employees[key], val)
            }
          }
          }, 300)
        
        })
      });
    }
  },
  watch: {
    excelFiles(newVal) {
      if (newVal.length > 1) {
        this.excelFiles = newVal[newVal.length - 1];
      }
    },
    amountType: function (val) {
      this.employees.forEach((employee) => {
        employee.amount = 0;
        if (val === 'percentage') {
          employee.maxAmount = this.residualPercents = 10000;
        } else {
          employee.maxAmount = this.residualAmount = this.totalPay;
        }
      });
      this.isDisabledRemainButton = false;
      this.checkResidual();
    },
    residualAmount: function () {
      if (this.employees.length) {
        let isDisabled = true;
        this.employees.map((employee) => {
          if (employee.amount === 0) {
            isDisabled = false;
          }
        });
        this.isDisabledRemainButton = isDisabled;
      }
    }
  },
  methods: {
    checkResidual() {
      this.residualAvailable =
        (this.amountType === "amount" && this.residualAmount > 0) ||
        (this.amountType === "percentage" && this.residualPercents > 0);
    },
    beforeExcelUpload (file) {
      const isLt1M = file.size / 1024 / 1024 < 50;

      if (!isLt1M) {
        this.$message.error(this.$t('form.validation.avatar-size', { size: '50MB' }));
      }
      return isLt1M;
    },
    handleExceed () {
      this.$message.warning(`The limit is 1`);
    },
    uploadExcel(request) {
      this.amountType = 'percentage';
      const fd = new FormData();

      fd.append('file', request.file);

      this.$adminApi.post(`api/v1/entities/teams/${this.$route.params.teamId}/reconciliation/upload`, fd).then((response) => {
          if (response.data.status === 'Failed') {
            this.$message.error(Object.keys(response.data.payload.errorMessages)[0]);
          } else {
            const usersData = response.data.payload.userInfo;
            usersData.forEach((data) => {
              this.employees = this.employees.map((employee) => {
                if (employee.empUid === data.user) {
                  this.changeAmount(employee, data.amount / 100);
                }
                return employee;
              });
            });
            this.$forceUpdate();
          }
      });
    },
    submitForm (formName = '') {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.fullScreenLoading = true;
          let users = [];
          this.employees.map((employee) => {
            users.push({
              user: employee.empUid,
              amount: employee.amount
            });
          });
          this.$adminApi.post(`api/v1/entities/teams/${this.$route.params.teamId}/reconciliation`, {
            type: this.amountType,
            strategy: this.poolingStrategy,
            periodStart: this.$route.params.startDate || '',
            periodEnd: this.$route.params.endDate || '',
            users: users
          }).then((response) => {
            this.fullScreenLoading = false;
            this.$store.dispatch('setReConciliationResponse', response.data);
            this.$router.push({ name: 'ReConciliationThankYou' });
          }).catch(() => {
            this.fullScreenLoading = false;
            this.$message.error(this.$t('form.something-wrong'));
          });
        } else {
          return false;
        }
      });
    },
    changeAmount (employee, newValue) {
      newValue = (newValue * 100) || 0;
      const oldValue = employee.amount || 0;
      const newResidualValue = this.roundToDecimals(newValue - oldValue);
      if (this.amountType === 'amount') {
        this.residualAmount -= newResidualValue;
      } else {
        this.residualPercents -= newResidualValue;
      }
      this.employees.map((user) => {
        if (user.id !== employee.id) {
          user.maxAmount = ((this.amountType === 'amount') ? this.residualAmount : this.residualPercents) + user.amount;
        }
      });
      employee.amount = newValue;
      this.$forceUpdate();
      this.checkResidual()
    },
    equalToAll () {
      this.resetForm();
      const totalAmount = (this.amountType === 'amount') ? this.totalPay : 10000;
      const equalPart = Math.floor(totalAmount / this.employees.length);
      this.employees.map((employee) => {
        employee.amount = employee.maxAmount = equalPart;
        if (this.amountType === 'amount') {
          this.residualAmount = this.roundToDecimals(this.residualAmount - equalPart);
        } else {
          this.residualPercents = this.roundToDecimals(this.residualPercents - equalPart);
        }
      });
      this.employees.map((employee) => {
        employee.maxAmount = ((this.amountType === 'amount') ? this.residualAmount : this.residualPercents) + employee.amount;
      });
      this.$forceUpdate();
      this.$refs['setAmountForm'].validate();
      this.checkResidual();
    },
    equalToRemain () {
      const countNotFilledAmount = this.employees.filter((obj) => obj.amount === 0).length;
      const equalPart = Math.floor(((this.amountType === 'amount') ? this.residualAmount : this.residualPercents) / countNotFilledAmount);
      this.employees.map((employee) => {
        if (employee.amount === 0) {
          employee.amount = employee.maxAmount = equalPart;
          if (this.amountType === 'amount') {
            this.residualAmount = this.roundToDecimals(this.residualAmount - equalPart);
          } else {
            this.residualPercents = this.roundToDecimals(this.residualPercents - equalPart);
          }
        } else {
          employee.maxAmount -= equalPart;
        }
      });
      this.employees.map((employee) => {
        employee.maxAmount = ((this.amountType === 'amount') ? this.residualAmount : this.residualPercents) + employee.amount;
      });
      this.$forceUpdate();
      this.$refs['setAmountForm'].validate();
      this.checkResidual();
    },
    resetForm () {
      this.employees.map((employee) => {
        this.changeAmount(employee, 0);
      });
    }
  }
};
</script>

<style scoped lang="scss">
.amount {
  h2 {
    color: #000000;
    font-size: 16px;
    font-family: "Raleway Bold", serif;
    text-align: center;
  }
}

.employees {
  h3 {
    color: #000000;
    font-size: 16px;
    font-family: "Raleway Medium", serif;
  }
}

.el-input-number {
  width: 100%;
}

.amount-type-change {
  text-align: center;
}

.equals-buttons {
  button {
    height: 100%;
    min-height: 54px;
    white-space: normal;
  }
}

.reconciliation-excel__manually {
  text-align: center;
  margin: 20px;
  font-size: 3rem;
  color: #C0C4CC;
}
</style>
